import protoRoot from "../proto-root";
import DataBuildInformation from "../private/DataBuildInformation";
import SupportedFeatures from "../private/SupportedFeatures";

const name = "startMonitoringRPCRequest";

function create(options?: { webRTCCreateOffer?: { sdp: string } }) {
  const StartMonitoringRPCRequest = protoRoot.lookupType("comm.StartMonitoringRPCRequest");

  const payload: Record<string, unknown> = {
    versionInfo: DataBuildInformation.create(),
    supportedFeatures: SupportedFeatures.create()
  };

  if (options?.webRTCCreateOffer) {
    const WebRTCCreateOfferMessage = protoRoot.lookupType("comm.WebRTCCreateOfferMessage");
    payload.webRTCCreateOffer = WebRTCCreateOfferMessage.create({ sdp: options.webRTCCreateOffer.sdp });
  }

  return {
    payload: StartMonitoringRPCRequest.create(payload),
    name
  };
}

const startMonitoringRPCRequest = {
  create,
  name
};

export default startMonitoringRPCRequest;
